/**
 * Founder Control Center v2 · Operations · Proveedores overview.
 *
 * Honest overview: hoy `/api/providers` es un endpoint **org-context** (cada org
 * gestiona sus propios proveedores para Expenses). NO existe un endpoint
 * platform-wide cross-org. Este panel documenta esa realidad y enlaza al CRUD
 * org-context existente (`/providers`), sin inventar mocks.
 *
 * 0 backend tocado · 0 endpoints nuevos · 0 mocks. Cuando exista el endpoint
 * cross-org (sprint backend posterior) este panel se enriquecerá con tabla
 * agregada por org.
 */
import { Link } from "react-router-dom";
import { Truck, ArrowRight, Receipt, Info } from "@phosphor-icons/react";

export default function ProveedoresOverview() {
  return (
    <div className="space-y-4" data-testid="proveedores-overview-root">
      <header>
        <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--ag-gold)] font-semibold flex items-center gap-1.5">
          <Truck size={11} weight="fill" /> Operations · Proveedores
        </div>
        <h2 className="font-display text-2xl font-bold tracking-tight text-[var(--ag-text)] mt-1">
          Proveedores de centros
        </h2>
        <p className="text-xs text-[var(--ag-text-dim)] mt-1">
          Catálogo de proveedores asociados a gastos por organización. Hoy se gestiona en contexto org-level (cada centro mantiene su lista).
        </p>
      </header>

      <section className="rounded-lg border border-[var(--ag-gold)]/30 bg-[var(--ag-gold)]/5 p-5" data-testid="proveedores-info">
        <div className="flex items-start gap-3">
          <Info size={18} weight="fill" className="text-[var(--ag-gold)] mt-0.5 shrink-0" />
          <div>
            <h3 className="font-display text-sm font-bold tracking-tight text-[var(--ag-text)] mb-1">
              Endpoint actualmente org-context
            </h3>
            <p className="text-xs text-[var(--ag-text-dim)]">
              <code>/api/providers</code> opera en el contexto de la org del usuario logueado (cada centro mantiene su propio listado para asignar a Expenses). No existe hoy un endpoint cross-org para que el founder vea proveedores de todos los centros agregados.
            </p>
            <div className="text-[10px] text-[var(--ag-text-muted)] mt-2 pt-2 border-t border-[var(--ag-gold)]/20">
              Sprint backend posterior: <code>GET /api/superadmin/providers</code> agregará por slug del proveedor con conteo de orgs que lo usan. Sin mocks introducidos mientras tanto.
            </div>
          </div>
        </div>
      </section>

      <section className="grid sm:grid-cols-2 gap-3" data-testid="proveedores-actions">
        <Link
          to="/providers"
          className="group rounded-lg border border-[var(--ag-border)] bg-[var(--ag-surface)] p-4 hover:border-[var(--ag-gold)]/50 hover:bg-[var(--ag-gold)]/5 transition-colors"
          data-testid="proveedores-link-org"
        >
          <div className="flex items-center justify-between">
            <Truck size={18} weight="duotone" className="text-[var(--ag-gold)]" />
            <ArrowRight size={12} className="text-[var(--ag-text-muted)] group-hover:text-[var(--ag-gold)]" />
          </div>
          <div className="font-display text-sm font-bold tracking-tight mt-2">Gestionar proveedores</div>
          <div className="text-[10px] text-[var(--ag-text-dim)] mt-0.5">
            CRUD per-org · /providers · 360 grados con Expenses
          </div>
        </Link>

        <Link
          to="/expenses"
          className="group rounded-lg border border-[var(--ag-border)] bg-[var(--ag-surface)] p-4 hover:border-[var(--ag-gold)]/50 hover:bg-[var(--ag-gold)]/5 transition-colors"
          data-testid="proveedores-link-expenses"
        >
          <div className="flex items-center justify-between">
            <Receipt size={18} weight="duotone" className="text-[var(--ag-gold)]" />
            <ArrowRight size={12} className="text-[var(--ag-text-muted)] group-hover:text-[var(--ag-gold)]" />
          </div>
          <div className="font-display text-sm font-bold tracking-tight mt-2">Gastos & facturas org</div>
          <div className="text-[10px] text-[var(--ag-text-dim)] mt-0.5">
            Asignación proveedor↔gasto · /expenses
          </div>
        </Link>
      </section>
    </div>
  );
}
